<template>
    <div class="page">
        <div class="weui-msg">
            <div class="weui-msg__icon-area">
                <i class="weui-icon-waiting weui-icon_msg"></i>
            </div>
            <div class="weui-msg__text-area">
                <h2 class="weui-msg__title">未出库跑腿单</h2>
                <p class="weui-msg__desc">
                    未出库的跑腿单如果已送达请及时处理，因为客户可能会取消该订单导致系统无法给您结算。。
                </p>
            </div>
            <div class="weui-cells">
                <div class="weui-cell" style="text-align: left;">
                    <div class="weui-cell__bd">
                        <p>订单编号</p>
                    </div>
                    <div class="weui-cell__ft">{{order.orderNo}}</div>
                </div>
                <div class="weui-cell" style="text-align: left;">
                    <div class="weui-cell__bd">
                        <p>下单时间</p>
                    </div>
                    <div class="weui-cell__ft">{{order.createdAt}}</div>
                </div>
                <div class="weui-cell" style="text-align: left;">
                    <div class="weui-cell__bd">
                        <p>下单人员</p>
                    </div>
                    <div class="weui-cell__ft">{{order.initiator}}</div>
                </div>
                <div class="weui-cell" style="text-align: left;">
                    <div class="weui-cell__bd">
                        <p>联系电话</p>
                    </div>
                    <div class="weui-cell__ft">{{order.initiatorPhone}}</div>
                </div>
                <div class="weui-cell" style="text-align: left;">
                    <div class="weui-cell__bd">
                        <p>跑单人员</p>
                    </div>
                    <div class="weui-cell__ft">{{order.acceptUser}}</div>
                </div>
                <div class="weui-cell" style="text-align: left;">
                    <div class="weui-cell__bd">
                        <p>联系电话</p>
                    </div>
                    <div class="weui-cell__ft">{{order.acceptUserPhone}}</div>
                </div>
            </div>
            <div class="weui-msg__opr-area">
                <p class="weui-btn-area">
                    <a href="javascript:;" class="weui-btn weui-btn_primary" @click="sign">已完成派送</a>
                </p>
            </div>
            <div class="weui-msg__extra-area">
                <div class="weui-footer">
                    <p class="weui-footer__links">
                        <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
                    </p>
                    <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";
import moment from "moment";
const wx = require("weixin-js-sdk");

export default {
  data() {
    return {
      order: {},
      paotuiId: "",
      encodeToken: "",
      token: "",
      year: moment().format("YYYY")
    };
  },
  created() {
    this.paotuiId = this.$route.params.paotuiId;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    axios
      .get("/api/paotuiOrder/getById/" + this.paotuiId)
      .then(res => {
        if (res.data.success) {
          this.order = res.data.data;
          this.order.createdAt = moment(this.order.createdAt).format(
            "YYYY-MM-DD HH:mm:ss"
          );
        } else {
          weui.alert("获取跑腿单信息失败");
        }
      })
      .catch(err => {
        weui.alert("获取跑腿单信息失败");
      });
  },
  methods: {
    sign() {
      let that = this;
      if (!this.order) {
        weui.alert("跑腿信息加载未完成");
        return;
      } else {
        weui.confirm(
          "确定已完成派送？",
          function() {
            axios
              .put(
                "/api/paotuiOrder/paotuiLeaderSignRollModule/" + that.order._id
              )
              .then(res => {
                if (res.data.success) {
                  weui.toast("处理成功", 1000);
                } else {
                  setTimeout(function() {
                    weui.alert(res.data.message);
                  }, 1000);
                }
              })
              .catch(err => {
                console.log(err);
                weui.alert("处理失败");
              });
          },
          function() {}
        );
      }
    }
  }
};
</script>

<style scoped>
.weui-footer {
  position: fixed;
  bottom: 10px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>





// WEBPACK FOOTER //
// src/components/operations/PaotuiLeaderSign.vue